export const InformationFieldWrapper = ({ children }: { children: React.ReactNode }) => {
  return <tr className="py-1 md:py-2 text-sm md:text-base">{children}</tr>;
};
